module.exports = "/img/_/_/_/assets/images/creeper/book/epic//2.jpg?6ee70b77c8d3e027df74394da8d29f01";